import axios from "axios";

const envs = [
  {
    url: "localhost",
    api: "https://test-services.csg.pagerduty.com/",
  },
  {
    url: "report-marketplace-dev.innovation.csg.pagerduty.com",
    api: "https://test-services.csg.pagerduty.com/",
  },
  {
    url: "report-marketplace.innovation.csg.pagerduty.com",
    api: "https://services.csg.pagerduty.com/",
  },
];

const getHostName = () => {
  const hostname = window.location.hostname;
  const currentEnv = envs.filter((env) => {
    return env.url === hostname;
  });

  return currentEnv[0]?.api || "";
};


export const API_BASE_URL = getHostName();


//
const api: any = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true
});

api.defaults.headers.common["Content-Type"] =
  "application/x-www-form-urlencoded";

api.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    const status = error.response?.status;
    if (
      (status === 401 || status === 403) &&
      !window.location.pathname.includes("/unauthorized")
    ) {
      localStorage.clear();
      window.location.replace("/unauthorized");
    }
    return Promise.reject(error);
  }
);

interface apiRequestProps {
  method: string,
  url: string,
  data?: any,
  headers?: any,
}

export const apiRequest = async ({ method, url, data, headers }: apiRequestProps) => {
  const token = localStorage.getItem("token");
  if (token) {
    api.defaults.headers.common["Authorization"] = `CsgPDBearer ${token}`;
  }
  let error = null;
  let response = null;
  try {
    response = await api[method.toLowerCase()](url, data, { headers });
    return [error, response ? response.data : response];
  } catch (e: any) {
    error = {
      error: e,
      message: e.response?.data.message,
      status: e.response?.status,
    };
    return [error, response];
  }
};
